/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 * 
 * Unauthorized copying of the code in this file, completely or partially, 
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 * 
 * Written by 'Vishal Goel' <vishal@wakencode.com>, May 2020
 *
 *****************************************************************************/


import React from "react";
import Save from "@material-ui/icons/Save";
import Delete from "@material-ui/icons/Delete";
import classes from "./TopButton.module.css";
import { constant } from "../../../shared/constants/constants";
import { useSelector } from "react-redux";

// Top buttons(save and delete) on map
const TopButton = (props) => {
  const profileName = useSelector((state) => state.auth.profileName);
  let renderer = (
    <div className={classes.Container}>
      <div
        className={classes.IconCont}
        style={{ marginRight: "16px" }}
        onClick={props.saveGeometries}>
        <button
          title={constant.SAVE_ICON_HOVER_MSG}
          className={classes.IconBtn}>
          <Save color="inherit" />
        </button>
      </div>
      <div className={classes.IconCont} onClick={props.deleteGeometry}>
        <button
          title={constant.DELETE_ICON_HOVER_MSG}
          className={classes.IconBtn}>
          <Delete color="secondary" />
        </button>
      </div>
    </div>
  );
  if (profileName && !profileName.toLowerCase().includes("admin"))
    renderer = null;
  return renderer;
};

export default React.memo(TopButton);
